const ContentWrapper = ({ children, open }) => {
	return (
		<div
			className={`flex flex-col gap-2 ${open ? 'max-h-[1000px] opacity-100' : 'max-h-0 overflow-hidden opacity-0'} transition-all duration-300 ease-in-out`}
		>
			{children}
		</div>
	);
};

export default ContentWrapper;
